module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Se désabonner',
        unsubscribeSubHeader: 'Voulez-vous vous désabonner de votre abonnement?',
        youHaveSaved: 'vous avez économisé',
        since: 'depuis',
        youWillSave: 'Vous économiserez',
        nextYear: 'au cours de la prochaine année grâce à cet abonnement.',
        qty: 'Qté',
        yearlySavings: 'économies annuelles',
        nevermindCTA: 'Ce n’est pas grave',
        unsubscribeCTA: 'Se désabonner',
        item: `ARTICLE ${vars[0]}`,
        skipNextDelivery: 'Sauter plutôt la prochaine livraison'
    };

    return resources[label];
};
